// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CancelDiscountModal_wrapper__YxNy3","actions":"CancelDiscountModal_actions__SdVrR"};